export const UserRoles = {
  Admin: 'Admin',
  OpoEmployee: 'OpoEmployee',
  FuneralHomeEmployee: 'FuneralHomeEmployee',
  ReferralUser: 'ReferralUser'
};
